import { stringLiteral } from '@execonline-inc/decoders';
import { array, Decoder, field, number, oneOf, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import {
  ClientGroup,
  CollaboratorAccess,
  CollaboratorAccessResource,
  PermissionOption,
  PermissionType,
} from './Types';

const permissionTypeDecoder: Decoder<PermissionType> = oneOf([
  stringLiteral<PermissionType>('organization'),
  stringLiteral<PermissionType>('private'),
  stringLiteral<PermissionType>('client-groups'),
]);

const permissionOptionDecoder: Decoder<PermissionOption> = succeed({})
  .assign('value', field('value', permissionTypeDecoder))
  .assign('label', field('label', string));

const clientGroupDecoder: Decoder<ClientGroup> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('membersCount', field('members_count', number));

const collaboratorAccessDecoder: Decoder<CollaboratorAccess> = succeed({})
  .assign('permissionType', field('permission_type', permissionTypeDecoder))
  .assign('clientGroupIds', field('client_group_ids', array(number)))
  .assign('options', field('options', array(permissionOptionDecoder)))
  .assign('clientGroups', field('client_groups', array(clientGroupDecoder)));

export const collaboratorAccessResourceDecoder: Decoder<CollaboratorAccessResource> =
  resourceDecoder(collaboratorAccessDecoder);
